import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { formatEmpty } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function LoadIdCell({ cell, actionCallback }) {
  const key = nullCheck(cell, "id", "column", "idKey");
  const loadId = nullCheck(cell, "", "row", "original", key);
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="body1"
        onClick={e => {
          e.stopPropagation();
          actionCallback({ action: "load-profile", loadId: loadId });
        }}
        sx={{
          color: active ? "white" : "primary.60",
          "&:hover": {
            cursor: "pointer"
          }
        }}
      >
        {formatEmpty(cell.value).toUpperCase()}
      </Typography>
    </span>
  );
}

LoadIdCell.propTypes = {
  cell: PropTypes.object,
  actionCallback: PropTypes.func
};